export default "__VITE_ASSET__Crse4Wao__"